var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotierenR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Rotieren-R__Icn/40px/Rotieren-R",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Rotieren-R__Icn/40px/Plus-Tools",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Rotieren-R__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Rotieren-R__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Rotieren-R__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Rotieren-R__Group",
    transform: "matrix(-1 0 0 1 28 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.77891162,8.10218341 L4.7967403,9.20456288 L0.554099615,4.96192219 L4.77481999,0.741201816 L5.83265174,1.79903356 L3.632,3.99920182 L8,4 C12.418278,4 16,7.581722 16,12 C16,16.418278 12.418278,20 8,20 C3.66061982,20 0.128185402,16.5450545 0.00341076058,12.2358776 L0,12 L1.77777778,12 C1.77777778,15.4364384 4.56356156,18.2222222 8,18.2222222 C11.4364384,18.2222222 14.2222222,15.4364384 14.2222222,12 C14.2222222,8.63515402 11.5513037,5.8941345 8.21391089,5.78138579 L8,5.77777778 L3.454,5.77720182 L5.77891162,8.10218341 Z",
    id: ".._.._src_svg_Icn_40px_Rotieren-R__Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotierenR);
export default __webpack_public_path__ + "static/media/Rotieren-R.2950457bdffeb1cb44e0d706330ca49a.svg";
export { ForwardRef as ReactComponent };